// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1uLQJ","info":"PatientInfo_info__3bxL3"};